export const userLandingPath = (user) => {
  if (user?.role_level === 1) return '/admin';
  return user?.can_view_itinerary_dashboard ? '/dashboard' : '/dashboard/forms';
};

export const trackingDashboardPath = (user) => (
  user?.role_level === 1
    ? '/admin/dashboard-seguimiento'
    : '/dashboard/dashboard-seguimiento'
);

export const userItineraryNavigationPaths = (user) => [
  ...(user?.can_view_itinerary_dashboard ? ['/dashboard'] : []),
  ...(user?.can_view_recurring_agenda ? ['/dashboard/itinerary'] : []),
];
